import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements OnInit {
    public allowedFileTypes = ['pdf', 'jpeg', 'jpg', 'png', 'webp'];
    @Output() setFile: EventEmitter<any> = new EventEmitter<any>();
    @Input() document: {
        [key: string]: any;
    };
    public selectedFile: {
        file: File;
        mediaUrl: string;
        fileType: string;
    };
    constructor(private toast: ToastrService) {}

    ngOnInit(): void {}
    async selectFile(event: Event) {
        const fileList = (event.target as HTMLInputElement).files;
        if (fileList) {
            await this.pickFile(fileList[0]);
        }
    }

    private async pickFile(file: File) {
        const fileType = file.name.split('.').pop()?.toLowerCase();
        if (!this.fileValid(file)) {
            return;
        }

        this.readFile(file, fileType);
    }

    private readFile(file: File, fileType: string) {
        const reader = new FileReader();
        reader.onloadend = async () => {
            const result = reader.result as string;
            this.selectedFile = {
                fileType: fileType,
                mediaUrl: result.replace('unsafe:', ''),
                file: file,
            };
            this.setFile.emit({
                fileType: fileType,
                mediaUrl: result.replace('unsafe:', ''),
                file: file,
            });
        };
        reader.onerror = () => {
            this.toast.error('Error reading file');
        };
        reader.readAsDataURL(file);
    }

    private fileValid(file: File): boolean {
        // Extract file extension from MIME type
        const fileType = file.type.split('/').pop()?.toLowerCase();
        // Check if the file type is allowed
        if (!fileType || !this.allowedFileTypes.includes(fileType)) {
            this.toast.error('File type is not allowed');
            return false;
        }
        const maxFileSize = 30 * 1024 * 1024;
        if (file.size > maxFileSize) {
            this.toast.error('File size should be less than 30MB');
            return false;
        }
        return true;
    }

    public removeSelectedFile() {
        this.selectedFile = null;
        this.setFile.emit(null);
    }

    public viewImage(url: string) {
        window.open(url, '_blank');
    }
}
